import React, {ButtonHTMLAttributes} from "react";
import {NavLink} from "react-router-dom";

interface ButtonPillUppercaseProps {
    label?: string,
    className?: string,
    link?: string,
    type?: ButtonHTMLAttributes<HTMLButtonElement>["type"],
    as?: string,
    disabled?: boolean;
    icon?: React.ReactNode,
    openInNewWindow?: boolean,
    onClick?: (e: any) => void,
}

const ButtonPill: React.FC<ButtonPillUppercaseProps> = (
    {
        label = '',
        className = '',
        link = '',
        type = 'button',
        icon,
        onClick = () => {},
        openInNewWindow = false,
        disabled = false,
    }
) => {
    return link && link !== "" ? (
        <NavLink
            to={link}
            className={`ickonic-button ickonic-button--pill button ${className}`}
            onClick={onClick}
            target={openInNewWindow ? "_blank" : "_self"}
        >
            <div className="ickonic-button__inner">
                {label && <span>{label}</span>}
                {icon && icon}
            </div>
        </NavLink>
    ) : (
        <button
            className={`ickonic-button ickonic-button--pill button ${className}`}
            onClick={onClick}
            type={type}
            disabled={disabled}
        >
            <div className="ickonic-button__inner">
                {label && <span>{label}</span>}
                {icon && icon}
            </div>
        </button>
    );
};

export default ButtonPill;
